import { ApiRequest, ApiResponse, HttpMethod } from '@axl/accel-framework/api';
import { CourseItemTaskAnswerStatus } from '@axl/accel-framework/models';
import { StudentCourseProgress } from 'models';

type CourseItemTaskFieldModel = {
    id: string;
    value: any;
}

export type CreateTaskAnswerRequestModel = {
    courseItemTaskId: string,
    studentCourseItemProgressId: string,
    text: string,
    files: string[],
    fields: CourseItemTaskFieldModel[]
}
export class CreateTaskAnswerRequest extends ApiRequest {
    public method = HttpMethod.POST;
    public url: string = `/student-course-item/task-answer`;
    public body = {
        ...this.model
    }

    constructor(public model: CreateTaskAnswerRequestModel) {
        super();
    }
}

export class CreateTaskAnswerResponse extends ApiResponse {
    id: string;
    status: CourseItemTaskAnswerStatus;
    progress: StudentCourseProgress;
    constructor(response: any) {
        super(response);
        this.id = this.body.answerId;
        this.status = this.body.answerStatus;
        this.progress = StudentCourseProgress.fromJson(this.body.progress);
    }
}